import { render, staticRenderFns } from "./OTPComponent.vue?vue&type=template&id=1ea38190&scoped=true"
import script from "./OTPComponent.vue?vue&type=script&lang=js"
export * from "./OTPComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea38190",
  null
  
)

export default component.exports